import { Component, Input } from '@angular/core';
import { BaseComponent } from '@hub/common/BaseComponent';
import { ModelError } from '@hub/models/ModelError';


@Component({
    selector: 'batch-errors',
    templateUrl: 'batch-errors.component.html'
})
export class BatchErrorsComponent extends BaseComponent {

    constructor() {
        super();
    }

    @Input() public set Errors(modelErrors: ModelError[]) {
        this.MyErrors = modelErrors.sort((a, b) => {
            if (a > b) {
                return 1;
            } else if (a < b) {
                return -1;
            } else {
                return 0;
            }
        });
    }

    public MyErrors: ModelError[] = [];

    public getRowNumber(error: ModelError) {
        return error.Key.split(".")[0];
    }
}
